/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { CloseOutlined } from '@mui/icons-material';
import { Avatar, Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { LanguageContext } from '../../../libs/Context';
import MainCard from '../../../UiComponents/Cards/MainCard';
import Loading from '../Loaders/FullWidthLoader/Loading';
import useDebounce from '../../Hooks/useDebounce';
import { getMeetingsList, getSpeakersList } from '../../../containers/actions/meeting_actions';
import useDidMountEffect from '../../../libs/CustomHooks/UseDidMountEffect';
import { getLikedUsers } from '../../../containers/actions/feeds_actions_new';
import GroupUserSvgIcon from '../../../assets/SvgIcons/GroupUserSvgIcon';
import NoData from '../NoData';
import Meetings from '../../../assets/NoDataImages/NoMeetings.svg';
import { toContainHTML } from '@testing-library/jest-dom/matchers';

interface iQueryParams {
	skip?: number;
	limit?: number;
	count?: number;
	type?: string;
	id?: string;
	sessionId?: string;
	search?: string;
}
interface iAttendee {
	userId : string;
	email : string;
	name : string;
}
interface iProfileImg {
	key?: string;
	type?: string;
	url: string;
}
interface iSpeaker {
	_id?: string;
	speakerImage:iProfileImg;
	speakerEmail: string;
	speakerName: string;
	designation: string;
	meetingDescription: string;
	organization: string;
	linkedinUrl: string;
	facebookUrl: string;
	twitterUrl: string;
	websiteUrl?: string;
}
interface iAttendeeType
{
	count?: number;
	pageSkip?: number;
	itemsPerPage?: number;
	userList: object[];
	// speakerData: iSpeaker[];
	// shareWith: iAttendee[];
	loading: boolean;
	scrollLoading: boolean;
	relations:any
}
const AvatarListPopup = (props) =>
{
	const { handleAttendeesClose, attendees, requestType, requestId, list = [], meetingData } = props;
	const { language } = useContext(LanguageContext);
	const [ searchVal, setSearchVal ] = useState<string>('');
	const lastEleRef = useRef<HTMLSpanElement>(null);
	const totalParticipants = meetingData?.metaData?.relations?.length + meetingData?.metaData?.externalMembers?.length;

	console.log('totalParticipant', totalParticipants);
	const [ attendesList, setAttendesList ] = useState<iAttendeeType>({
		count         : 0,
		pageSkip      : 0,
		itemsPerPage  : 10,
		userList      : list?.length > 0 ? list : [],
		relations     : [],
		// speakerData   : list?.length > 0 ? list : [],
		// shareWith     : list?.length > 0 ? list : [],
		loading       : !(list?.length > 0),
		scrollLoading : false
	});
	const { itemsPerPage, pageSkip, userList, relations,
		loading } = attendesList;
	const [ filteredData, setFilteredData ] = useState<iAttendeeType>(attendesList);
	const baseUrl = process.env.REACT_APP_S3_BASE_URL;
	const debouncedSearchTerm = useDebounce(searchVal, 500);

	// Meeting...
	const fetchAttendesRecords = async () =>
	{
		setAttendesList((prev) => ({
			...prev,
			loading : true
		}));
		// For schedule only...
		const queryParams: iQueryParams = {
			id : requestId
		};

		try
		{
			const res = await getMeetingsList(queryParams);

			if (res.status)
			{
				const updateRelation = res?.data?.hasOwnProperty('metaData') ? res?.data?.metaData?.relations : res?.data?.relations;
				const relationCount = updateRelation?.reduce((acc, curr) => acc + curr?.count || 0, 0) || 0;
				const listData = res?.data?.hasOwnProperty('metaData') ? res?.data?.metaData?.externalMembers : res?.data?.shareWith;

				setAttendesList((prev) => ({
					...prev,
					loading   : false,
					relations : updateRelation,
					userList  : pageSkip === 0 ? listData : [ ...prev.userList, ...listData ],
					count     : relationCount + listData?.length
				}));
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading : false
			}));
			console.error('Error fetching webinar data:', err);
		}
	};

	// webinar
	const fetchSpeakersCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const res = await getSpeakersList(query);

			if (res?.status)
			{
				setAttendesList((prev) => ({ ...prev, count: res?.count }));
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading       : false,
				scrollLoading : false
			}));
			// eslint-disable-next-line no-console
			console.error('Error fetching count data:', err);
		}
	};

	const fetchSpeakerRecords = async () =>
	{
		pageSkip === 0 && setAttendesList((prev) => ({
			...prev,
			loading : true
		}));

		const queryParams:iQueryParams = {
			sessionId : requestId, // webinar id
			limit     : itemsPerPage || 10,
			skip      : pageSkip || 0
		};

		try
		{
			const res = await getSpeakersList(queryParams);

			if (res?.status)
			{
				if (pageSkip === 0)
				{
					const isCountRequired = res?.data?.length >= 10;
					const updateRelation = meetingData?.metaData?.relations || meetingData?.relations;
					const listData = meetingData?.metaData?.externalMembers || meetingData?.shareWith;

					const updatedState = {
						loading       : false,
						scrollLoading : false,
						userList      : pageSkip === 0 ? [ ...res?.data ?? [], ...listData ] : [ ...userList ?? [], ...res?.data ?? [] ],
						relations     : updateRelation,
						count         : res?.data?.length
					};

					if (isCountRequired)
					{
						fetchSpeakersCount(queryParams);
					}

					setAttendesList((prev) => ({
						...prev,
						...updatedState
					}));
				}

				else
				{
					// Handling Pagination
					const newArr = [ ...userList, ...res?.data ];

					setAttendesList((prev) => ({
						...prev,
						loading       : false,
						scrollLoading : false,
						userList      : newArr
					}));
				}
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading : false
			}));
			console.error('Error fetching webinar data:', err);
		}
	};

	// FeedsLikedUsers

	const likedUersCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const res = await getLikedUsers(requestId, query);

			if (res?.status)
			{
				setAttendesList((prev) => ({ ...prev, count: res?.count }));
				// setCount(res?.count);
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading       : false,
				scrollLoading : false
			}));
			// eslint-disable-next-line no-console
			console.error('Error fetching count data:', err);
		}
	};

	const likedUersList = async () =>
	{
		pageSkip === 0 && setAttendesList((prev) => ({
			...prev,
			loading : true
		}));
		const query:any = {
			limit : itemsPerPage,
			skip  : pageSkip
		};

		if (requestType === 'comment')
		{
			query.type = 'comment';
		}

		try
		{
			const res = await getLikedUsers(requestId, query);

			if (res?.status)
			{
				pageSkip === 0 && (res?.response?.data?.length >= 10 ? likedUersCount(query) : setAttendesList((prev) => ({ ...prev, count: res?.response?.data?.length })));
				setAttendesList((prev) => ({
					...prev,
					loading       : false,
					scrollLoading : false,
					userList      : pageSkip === 0 ? res?.response?.data : [ ...userList, ...res?.response?.data ]
				}));
			}
		}
		catch (err)
		{
			setAttendesList((prev) => ({
				...prev,
				loading       : false,
				scrollLoading : false
			}));
			console.log(err, '========================err');
		}
	};

	// Incoming Request...
	useEffect(() =>
	{
		if (requestType === 'webinar' && list?.length <= 0)
		{
			fetchSpeakerRecords();
		}
		else if (requestType === 'webinar' && list?.length > 0)
		{
			const updateRelation = meetingData?.hasOwnProperty('metaData') ? meetingData?.metaData?.relations : meetingData?.relations;

			const listData = meetingData?.hasOwnProperty('metaData') ? meetingData?.metaData?.externalMembers : meetingData?.shareWith;

			setAttendesList((prev) => ({
				...prev,
				loading   : false,
				relations : updateRelation,
				userList  : pageSkip === 0 ? listData : [ ...prev.userList, ...listData ],
				count     : updateRelation?.reduce((acc, curr) => acc + curr?.count || 0, 0) || 0 + listData?.length
			}));
		}
		else if (requestType === 'schedule')
		{
			fetchAttendesRecords();
		}
		else if (requestType === 'feedLikes' || requestType === 'comment')
		{
			likedUersList();
		}
		else
		{
			console.log('Oops! Check your request type...');
		}
	}, [ requestType ]);

	// Search Action...
	useDidMountEffect(() =>
	{
		const lowerCaseSearchVal = debouncedSearchTerm?.toLowerCase();

		let filteredUserList = userList || [];
		let filteredRelations = relations || [];
		let filteredRelationsCount = 0;

		if (debouncedSearchTerm)
		{
			const searchMatch = (item: any) =>
				item?.speakerName?.toLowerCase().match(lowerCaseSearchVal) ||
				item?.name?.toLowerCase().match(lowerCaseSearchVal) ||
				item?.email?.toLowerCase().match(lowerCaseSearchVal) ||
				item?.userData?.firstName?.toLowerCase()?.match(lowerCaseSearchVal);

			filteredUserList = userList?.filter(searchMatch);
			filteredRelations = relations?.filter(searchMatch);
			filteredRelationsCount = relations?.reduce((acc, curr) => acc + curr?.count || 0, 0) || 0;
		}

		// Update state with filtered data
		setFilteredData((prev) => ({
			...prev,
			userList  : filteredUserList,
			count     : filteredUserList.length + filteredRelationsCount,
			relations : filteredRelations,
			loading   : false
		}));
	}, [ debouncedSearchTerm, userList, requestType ]);

	const renderAttendeesList = () =>
	{
		const dataToRender = filteredData?.userList;

		if (dataToRender?.length === 0)
		{
			return <Typography align='center' color='gray'>No attendees found</Typography>;
		}

		return dataToRender?.map((item: any, index: number) => (
			<React.Fragment key={index}>
				<Stack display={'flex'} flexDirection={'row'} mb={1}>
					<Avatar
						src={item?.speakerImage?.url ||
								(item?.userId && `${baseUrl}/profile/${item?.userId}_profile.jpeg`)}
						//  ||'/images/icons/defaultUser.svg'}
						sx={{ width: '38px', height: '38px' }}
					/>
					<Stack display={'flex'} flexDirection={'column'} pl='var(--pixel8)'>
						<Typography>{item?.speakerName ?? item?.name ?? item?.userData?.firstName ?? item?.email ?? 'NA'}</Typography>
						<Typography fontSize={'var(--pixel12)'} color={'gray'} className='flexRow'>
							{item?.designation ?? item?.email ?? 'NA'}
						</Typography>
					</Stack>
				</Stack>
				{index === (userList.length - 2) && <span ref={lastEleRef} />}
			</React.Fragment>
		));
	};

	const dataLoop:any = searchVal === '' ? userList : filteredData?.userList;
	const relatnData:any = searchVal === '' ? relations : filteredData?.relations;

	return (
		<Dialog open={attendees} fullWidth maxWidth={'sm'}>
			<DialogTitle>
				<Grid container>
					<Grid item xs={12}>
						<Stack
							direction='row'
							justifyContent='space-between'
							alignItems='center'
						>
							<Typography variant='h6'>{props?.title ? props?.title : language?.attendees}&nbsp;
								<Typography variant='subtitle1' component={'span'}>
									({totalParticipants || (list?.length > 0 ? dataLoop?.length : attendesList?.count)})
								</Typography>
							</Typography>
							<IconButton onClick={handleAttendeesClose}>
								<CloseOutlined sx={{ cursor: 'pointer' }}/>
							</IconButton>
						</Stack>
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent >
				<Grid container direction={'column'}>
					<Grid item>
						<TextField
							size='small'
							variant='outlined'
							placeholder={language?.searchMembers}
							fullWidth
							value={searchVal}
							// disabled={searchVal === '' && dataLoop?.length === 0}
							onChange={(e) => setSearchVal(e.target.value.replace(/^\s+/, ''))}
							InputProps={{
								startAdornment : (
									<InputAdornment position='start'>
										<SearchIcon />
									</InputAdornment>
								)
							}}
						/>
					</Grid>
					<Grid item mt={1}>
						<MainCard>
							<Grid item sx={{ overflowY: 'auto', height: 'auto' }} display={'flex'} flexDirection={'column'}>
								{loading && <Loading />}
								{/* In UX it is not added, as per RP said to show relations also, iam adding for now later will change as per Manager's request. */}
								{relatnData?.length > 0 && relatnData?.map((each, index) => (
									<Stack key={index} direction='row' spacing={1} mb={1}>
										<Avatar alt='img' sx={{ width: '38px', height: '38px' }}>
											<GroupUserSvgIcon/>
										</Avatar>
										<span >{each?.name}</span>
										{/* {typeof each?.count === 'number' && <span >({each?.count})</span>} */}
									</Stack>
								))}
								{dataLoop?.length > 0 && dataLoop?.map((each:any, index) => (
									<Stack key={index} direction='row' spacing={1} mb={1}>

										<Avatar
											src={
												requestType === 'collaboration' && each?.profileImg ? each?.profileImg : each?.userId ? `${baseUrl}/profile/${each?.userId}_profile.jpeg` : '/images/icons/defaultUser.svg'}

											sx={{ width: '38px', height: '38px' }}
										/>

										{requestType === 'collaboration' && <Stack display={'flex'} flexDirection={'column'} pl='var(--pixel8)'>
											<Typography display='flex'>{each?.speakerName ?? each?.name ?? each?.userData?.firstName ?? each?.email ?? 'NA'}</Typography>
											{each?.email &&
												<Typography display='flex' fontSize={'var(--pixel12)'} color={'gray'}>
													{each?.email ?? ''}
												</Typography>
											}
										</Stack>}
										{(requestType !== 'feedLikes' && requestType !== 'Rms' && requestType !== 'collaboration') && <span className='flexRow'>{each?.email}</span>}
										{(requestType === 'feedLikes' || requestType === 'comment' || requestType === 'Rms') &&
											<Stack display={'flex'} flexDirection={'column'} pl='var(--pixel8)'>
												<Typography display='flex'>{each?.speakerName ?? each?.name ?? each?.userData?.firstName ?? each?.email ?? 'NA'}</Typography>
												{(each?.designation || each?.email) &&
												<Typography fontSize={'var(--pixel12)'} color={'gray'} display='flex'>
													{each?.designation ?? each?.email ?? ''}
												</Typography>
												}
											</Stack>
										}
										{/* {index === (userList.length - 2) && <span ref={lastEleRef} />} */}
									</Stack>
								))}

								{!loading && relatnData?.length === 0 && dataLoop?.length === 0 &&
								<NoData noDataHead={(requestType === 'feedLikes' || requestType === 'comment') ? 'No data Found' : 'No Attendees Found'}
									color='lightTxt'
									height={'100%'}
									src={<img src={Meetings}/>
									}
								/>}
							</Grid>
						</MainCard>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default AvatarListPopup;